import React from 'react';
import { Card, CardContent, Typography, Box, CardActionArea, Grid} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import OpenInNewIcon from '@mui/icons-material/Launch';

function WebCard({ title, icon, onClick }) {
  return (
    <Card sx={{ minWidth: 150,mb:10 }}>
      <CardActionArea onClick={onClick}>
        <CardContent sx={{ textAlign: 'center' }}>
          <img src={icon} style={{ width: '140px', height: '140px' }} alt="App Icon" />
          <Typography variant="h5" component="div" sx={{ mt: 3 }} >
            {title}
          </Typography>
          <Grid container justifyContent="center" sx={{ mt: 3, mb:2  }}>
            <OpenInNewIcon sx={{ fontSize: 40 }} />
          </Grid>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

export default WebCard;
